export enum DEPOSIT_PRODUCT_TYPE {
  TERM = 'TERM',
  OVERNIGHT = 'OVERNIGHT',
  NOTICE = 'NOTICE',
}

export interface DepositTakingBank {
  name: string;
  statutoryDepositGuaranteeScheme: {
    country: {
      name: string;
    };
    insuredAmount: number;
    currency: string;
  };
}

export interface ChildrenProps {
  children: React.ReactNode;
}
